import React, { useState, useEffect } from "react";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import { Link } from "react-router-dom";

const TourPackages = () => {
  const [packages, setPackages] = useState([]);
  const [stripe, setStripe] = useState(null);
  const isLoggedIn = localStorage.getItem("loggedInUser");
  useEffect(() => {
    // Load Stripe.js when the component mounts
    const stripePromise = loadStripe("pk_test_51NYCQeKoX4yf2BcDWx5A0S7Q6fbIUGmnbAQgVgqpKfFOZJeVG6gIByZbLXFmzinA9NwSPYsTSI1qTbsnc52l40s400toXeA94r");
    stripePromise.then((stripe) => {
      setStripe(stripe);
    });

    axios
      .get("https://journey-scape-main.vercel.app/api/auth/packages")
      .then((response) => {
        // Sort the packages based on the upload date (assuming you have an 'uploadDate' property)
        const sortedPackages = response.data.sort((a, b) => {
          return new Date(b.uploadDate) - new Date(a.uploadDate);
        });

        // Take only the first three packages
        const latestPackages = sortedPackages.slice(0, 3);

        setPackages(latestPackages);
      })
      .catch((error) => {
        console.error("Error fetching tour packages:", error);
      });
  }, []);

  const handleBookNow = async (pkg) => {
    try {
      if (!stripe) {
        console.error("Stripe.js has not been loaded yet.");
        return;
      }
  
      const price = parseFloat(pkg.price.replace(/,/g, '')); // Convert the price string to a number
  
      const response = await axios.post(
        "https://stripe-backend-delta.vercel.app/create-checkout-session",
        {
          title: pkg.title,
          price: price, // Use the numeric price
          images: [pkg.image], // Pass the image URL as an array
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      const { id } = response.data;
  
      // Redirect to Stripe Checkout
      const result = await stripe.redirectToCheckout({
        sessionId: id,
      });
  
      if (result.error) {
        console.error("Error redirecting to Checkout:", result.error);
      }
    } catch (error) {
      console.error("Error creating checkout session:", error);
    }
  };

  return (
    <>
      {/* ... (rest of the JSX code) */}
      <main id="content" className="site-main">

        <div className="package-section">
          <div className="container">
            <div className="package-inner">
              <div className="row">
                {packages.map((pkg) => (
                  <div key={pkg._id} className="col-lg-4 col-md-6">
                    <div className="package-wrap">
                      <figure className="feature-image">
                        <Link to={{
                                pathname: `/package/${pkg._id}`,
                                state: { packageData: pkg },
                              }}>
                          <img src={`https://journey-scape-main.vercel.app/uploads/${pkg.image}`} alt={pkg.title} />
                        </Link>
                      </figure>
                      <div className="package-price">
                        <h6>
                          <span>${pkg.price}</span> / per person
                        </h6>
                      </div>
                      <div className="package-content-wrap">
                        <div className="package-meta text-center">
                          <ul>
                            <li>
                              <i className="far fa-clock" />
                              {pkg.duration}
                            </li>
                            <li>
                              <i className="fas fa-user-friends" />
                              People: {pkg.people}
                            </li>
                            <li>
                              <i className="fas fa-map-marker-alt" />
                              {pkg.location}
                            </li>
                          </ul>
                        </div>
                        <div className="package-content">
                          <h3>
                            <Link to={{
                                pathname: `/package/${pkg._id}`,
                                state: { packageData: pkg },
                              }}>{pkg.title}</Link>
                          </h3>
                          <div className="review-area">
                            <span className="review-text">
                              ({pkg.reviews} reviews)
                            </span>
                            <div
                              className="rating-start"
                              title={`Rated ${pkg.rating} out of 5`}
                            >
                              {/* Your rating styles */}
                            </div>
                          </div>
                          <p>{pkg.description}</p>
                          <div className="btn-wrap">
                          <button
      onClick={() => handleBookNow(pkg)}
      className="button-text width-6"
      disabled={!isLoggedIn}
      title={isLoggedIn ? "Book Now" : "Please Login First"}
    >
      Book Now
    </button>
                            <Link
                              to={{
                                pathname: `/package/${pkg._id}`,
                                state: { packageData: pkg },
                              }}
                              className="button-text width-6"
                            >
                              Package Detail
                              
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default TourPackages;
